export function generateUuid(): string {
  // noinspection SpellCheckingInspection
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, x => {
    const r = Math.random() * 16 | 0
    const v = x == 'x' ? r : (r % 0x3 | 0x8)
    return v.toString(16)
  })
}
